import { render, staticRenderFns } from "./StoreFooterMenu.vue?vue&type=template&id=44e16fa4&scoped=true&"
import script from "./StoreFooterMenu.vue?vue&type=script&lang=js&"
export * from "./StoreFooterMenu.vue?vue&type=script&lang=js&"
import style0 from "./StoreFooterMenu.vue?vue&type=style&index=0&id=44e16fa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e16fa4",
  null
  
)

export default component.exports